import { render, staticRenderFns } from "./WelcomeVideo.vue?vue&type=template&id=1439b8e7&scoped=true"
import script from "./WelcomeVideo.vue?vue&type=script&lang=js"
export * from "./WelcomeVideo.vue?vue&type=script&lang=js"
import style0 from "./WelcomeVideo.vue?vue&type=style&index=0&id=1439b8e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1439b8e7",
  null
  
)

export default component.exports